jQuery(function($)
{
    /**
	 * @constructor
	 * @param {HTMLElement} element
	 */
    var Modal = function(element)
    {
        this.show = orion.show;
        this.hide = orion.hide;

        this.$html = $(document.documentElement);
        this.$body = $('body');

        this.$modal = $(element);
        this.$modal.addClass('js-modal');

        this.$backdrop = $('<div></div>').addClass('js-modal-backdrop');

        this.closeButtons = [];

        this.handleClickClose = $.proxy(this.handleClickClose, this);
        this.handleClickBackdrop = $.proxy(this.handleClickBackdrop, this);
        this.handleKeydown = $.proxy(this.handleKeydown, this);
        this.handlePressEscape = $.proxy(this.handlePressEscape, this);

        this.init();
    };

    /**
	 * Initialize Modal
	 */
    Modal.prototype.init = function()
    {
        this.initEvents();
        this.addCloseButton('.js-modal-close');
        if (!this.$modal.parent().is('.js-modal-backdrop'))
        {
            this.prepareBackdrop();
        }
        this.addBackdrop();
        this.showModal();
    };

    /**
	 * Init all events
	 */
    Modal.prototype.initEvents = function()
    {
        this.$modal.on('click', this.closeButtons.join(' '), this.handleClickClose);
        this.$backdrop.on('click', this.handleClickBackdrop);

        $(document).on('keydown', this.handleKeydown);
    };

    /**
	 * Prepare modal backdrop
	 */
    Modal.prototype.prepareBackdrop = function()
    {
        this.show(this.$modal);

        this.$backdrop.css({
            'position': 'fixed',
            'z-index': '101',
            'background-color': 'rgba(0,0,0,0.5)',
            'width': '100%',
            'height': '100%',
            'top': '0',
            'left': '0'
        });

        // Append the modal to the backdrop and hide it
        this.$backdrop.append(this.$modal);
        this.$backdrop.addClass('hidden');

        this.$body.append(this.$backdrop);
        console.log(orion);
        $('body').trigger(orion.constants.EventModalAppended);
    };

    /**
	 * Show modal
	 */
    Modal.prototype.showModal = function()
    {
        this.disableScroll();
        this.show(this.$modal);

        $('.js-modal').trigger(orion.constants.EventModalOpened);
    };

    /**
	 * Hide modal
	 */
    Modal.prototype.hideModal = function()
    {
        this.enableScroll();
        this.hide(this.$modal);

        $('.js-modal').trigger(orion.constants.EventModalClosed);
    };

    /**
	 * Disable scrolling to keep modal centered
	 */
    Modal.prototype.disableScroll = function()
    {
        this.$html.css({
            'overflow-y': 'scroll',
            'position': 'fixed',
            'width': '100%'
        });
    };

    /**
	 * Enable scrolling
	 */
    Modal.prototype.enableScroll = function()
    {
        this.$html.css({
            'overflow-y': '',
            'position': '',
            'width': ''
        });
    };

    /**
	 * Add backdrop
	 */
    Modal.prototype.addBackdrop = function()
    {
        var $modalParent = this.$modal.parent();

        if ($modalParent.is('.js-modal-backdrop'))
        {
            this.$modal = $modalParent;
        }
        else
        {
            this.$modal = this.$backdrop;
        }
    };

    /**
	 * Define/add modal close buttons
	 * @param {String} selector
	 */
    Modal.prototype.addCloseButton = function(selector)
    {
        this.closeButtons.push(selector);
        this.initEvents();
    };

    /**
	 * Handle click on close buttons to close the modal
	 * @param {MouseEvent} event
	 */
    Modal.prototype.handleClickClose = function(event)
    {
        var $target = $(event.target);

        // Check if the clicked element is defined as close button
        $.each(this.closeButtons, function(index, value)
        {
            var $current = $(value);

            if ($target.is($current))
            {
                this.hideModal();
            }
        }.bind(this));
    };

    /**
	 * Handle click on backdrop element to close the modal
	 * @param {MouseEvent} event
	 */
    Modal.prototype.handleClickBackdrop = function(event)
    {
        var $target = $(event.target);

        if ($target.is(this.$backdrop))
        {
            this.hideModal();
        }
    };

    /**
	 * Handle keypress events
	 * @param {KeyboardEvent} event
	 */
    Modal.prototype.handleKeydown = function(event)
    {
        switch (event.keyCode)
        {
        // ESC Key
        case 27:
            this.handlePressEscape();
        }
    };

    /**
	 * Handle escape keypress
	 */
    Modal.prototype.handlePressEscape = function()
    {
        this.hideModal();
    };

    /**
	 * Initialize jQuery plugin
	 * @param  {Object} options
	 * @return {Modal}
	 */
    $.fn.modal = function(options)
    {
        if ($(this).length)
        {
            return new Modal(this, options);
        }
    };
});
